import React from 'react'
import { connect } from 'react-redux'
import { selectors as UsersSelectors } from 'data/users'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import { revokeOrganizationSSO } from 'data/auth/actions'

import Informations from './Informations'
import SSO from './SSO'
import EmailPassword from './emailPassword'

const enhance = connect(
  state => ({
    organization: OrganizationsSelectors.getOrganization(state),
    isFree: OrganizationsSelectors.isFree(state),
    user: UsersSelectors.getCurrentUser(state),
    canManage: UsersSelectors.canCurrentUserManageOrganization(state),
  }),
  { revokeOrganizationSSO }
)

const Authentication = ({
  user,
  isFree,
  canManage,
  organization,
  revokeOrganizationSSO,
}) => {
  return (
    <div>
      {/* Learn more about SSO */}
      {<Informations organization={organization} />}

      {/* SSO */}
      {organization.authMethod === 'emailPassword' && (
        <SSO organization={organization} user={user} isFree={isFree} />
      )}

      {/* EmailPassword */}
      {canManage && (
        <EmailPassword
          canManage={canManage}
          organization={organization}
          onEnable={() => {
            revokeOrganizationSSO()
          }}
        />
      )}
    </div>
  )
}

export default enhance(Authentication)
